import { isNotNullish } from '../../common/utils';
import { DropdownOptions } from './types';

export const optionsInclude = (
  needles: DropdownOptions | null | undefined,
  haystack: DropdownOptions | null | undefined,
): boolean =>
  [needles]
    .flat()
    .filter(isNotNullish)
    .some((needle) =>
      [haystack]
        .flat()
        .filter(isNotNullish)
        .some((straw) => straw.value === needle.value),
    );
